<template>
  <div class="pagination-container" v-if="total > 0">
    <p class="total">
      {{ currentPage === 0 ? 1 : currentPage * perPage }}-{{
        Math.min((currentPage + 1) * perPage, total)
      }}
      of
      {{ total }}
    </p>
    <div
      class="start"
      @click="$emit('start')"
      :class="{ disabled: currentPage === 0 }"
    >
      <StopChevron
        direction="left"
        :color="currentPage === 0 ? 'sleet' : 'midnight'"
      />
    </div>
    <div
      class="back"
      @click="$emit('back')"
      :class="{ disabled: currentPage === 0 }"
    >
      <Chevron2
        :color="currentPage > 0 ? 'midnight' : 'sleet'"
        direction="left"
      />
    </div>
    <div
      class="forward"
      @click="$emit('forward')"
      :class="{ disabled: currentPage >= Math.ceil(total / perPage) - 1 }"
    >
      <Chevron2
        direction="right"
        :color="
          currentPage < Math.ceil(total / perPage) - 1 ? 'midnight' : 'sleet'
        "
      />
    </div>
    <div
      class="end"
      @click="$emit('end')"
      :class="{ disabled: currentPage >= Math.ceil(total / perPage) - 1 }"
    >
      <StopChevron
        direction="right"
        :color="
          currentPage >= Math.ceil(total / perPage) - 1 ? 'sleet' : 'moidnight'
        "
      />
    </div>
  </div>
</template>

<script>
import Chevron2 from '@/assets/icons/Chevron2.vue'
import StopChevron from '@/assets/icons/StopChevron.vue'
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  components: {
    Chevron2,
    StopChevron,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';
.pagination-container {
  justify-content: flex-start;
  display: flex;
  align-items: center;
  width: 100%;

  .total {
    min-width: 100px;
    padding-right: 2rem;
  }

  .start {
    margin-left: auto;
  }

  .disabled {
    pointer-events: none;
  }

  svg {
    height: 12px;
  }

  div {
    cursor: pointer;
    margin-left: 2rem;
  }

  p {
    font-size: 0.875rem;
  }
}
@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
  .pagination-container {
    width: auto;
    justify-content: flex-end;
  }
}

@media (min-width: 1200px) {
  .pagination-container {
    display: flex;
    align-items: center;

    svg {
      height: 14px;
    }

    p {
      font-size: 1rem;
    }
  }
}
</style>
